import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { BrestRegionWithLoader } from './loaders';
import { getCitiesByRegion } from '../../../actions/city/thunks';
import { RegionTypes } from '../../../types/Models/City/City';

export const BrestRegion = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCitiesByRegion(RegionTypes.BREST));
    }, []);

    return <BrestRegionWithLoader />;
};
